import { useCallback, useState } from 'react'
import { Alert, Snackbar } from '@mui/material'

/**
 * Hook + componente de feedback padronizado.
 *
 *   const { feedback, notify, FeedbackSnackbar } = useFeedback()
 *   notify('Ordem criada com sucesso!', 'success')
 *   <FeedbackSnackbar />
 */
export const useFeedback = () => {
  const [feedback, setFeedback] = useState({ open: false, message: '', severity: 'success' })

  const notify = useCallback((message, severity = 'success') => {
    setFeedback({ open: true, message, severity })
  }, [])

  const close = useCallback(() => setFeedback(current => ({ ...current, open: false })), [])

  const FeedbackSnackbar = useCallback(
    () => (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={feedback.open}
        autoHideDuration={5000}
        onClose={close}
      >
        <Alert onClose={close} severity={feedback.severity} sx={{ width: '100%' }}>
          {feedback.message}
        </Alert>
      </Snackbar>
    ),
    [feedback, close]
  )

  return { feedback, notify, close, FeedbackSnackbar }
}

export default useFeedback
